import { CONTRACT_ORIGIN_WARRANTY_ZERO } from "../../../../../../../../util/defaults/contrato";

export const isReplacementContractActive = (filters: any) =>
  filters?.origen?.length === 1 &&
  filters?.origen.includes(CONTRACT_ORIGIN_WARRANTY_ZERO);
